import { render, staticRenderFns } from "./AccountantsCommunicationMenu.vue?vue&type=template&id=0881df03&scoped=true&"
import script from "./AccountantsCommunicationMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsCommunicationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881df03",
  null
  
)

export default component.exports